<template>
  <b-card no-body class="mb-3">
    <b-card-header class="d-flex justify-content-between align-items-center">
      <strong>Coordinating Committee</strong>
      <b-button size="sm" variant="outline-danger" @click="$emit('remove')">
        Remove
      </b-button>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="2">
          <b-form-group label="Number">
            <b-form-input
              v-model.number="committee.number"
              type="number"
              min="1"
              @change="$emit('sync-numbers')"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="5">
          <b-form-group label="Name">
            <b-form-input v-model="committee.name" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="5">
          <b-form-group label="Description">
            <b-form-textarea v-model="committee.description" rows="2" maxlength="1000" />
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-between align-items-center mb-2">
        <strong>Technical committees</strong>
        <b-button size="sm" variant="outline-primary" @click="$emit('add-technical-committee')">
          Add technical committee
        </b-button>
      </div>

      <technical-committee-editor
        v-for="(technicalCommittee, tcIndex) in activeTechnicalCommittees"
        :key="technicalCommitteeKey(technicalCommittee, tcIndex)"
        :committee="committee"
        :technical-committee="technicalCommittee"
        :tc-key="technicalCommitteeKey(technicalCommittee, tcIndex)"
        :tc-move-options="tcMoveOptions"
        :keyword-move-options="keywordMoveOptionsFor(technicalCommittee, tcIndex)"
        :move-target="moveTargets[technicalCommitteeKey(technicalCommittee, tcIndex)]"
        :keyword-move-targets="keywordMoveTargets"
        :can-move="canMoveTechnicalCommittees"
        :can-move-keywords="canMoveKeywords"
        :inherit-source-options="inheritSourceOptions"
        @remove="$emit('remove-technical-committee', tcIndex)"
        @set-move-target="$emit('set-move-target', {
          tcKey: technicalCommitteeKey(technicalCommittee, tcIndex),
          target: $event,
        })"
        @move="$emit('move-technical-committee', { tcIndex, target: $event })"
        @sync-number="$emit('sync-technical-committee-number', technicalCommittee)"
        @add-keyword="$emit('add-keyword', tcIndex)"
        @remove-keyword="$emit('remove-keyword', { tcIndex, keywordIndex: $event })"
        @set-keyword-move-target="$emit('set-keyword-move-target', $event)"
        @move-keyword="$emit('move-keyword', {
          tcIndex,
          keywordIndex: $event.keywordIndex,
          target: $event.target,
        })"
        @check-keyword-similarity="$emit('check-keyword-similarity', $event)"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import TechnicalCommitteeEditor from './TechnicalCommitteeEditor.vue';

export default {
  name: 'CoordinatingCommitteeEditor',
  components: {
    TechnicalCommitteeEditor,
  },
  props: {
    committee: {
      type: Object,
      required: true,
    },
    canMoveTechnicalCommittees: {
      type: Boolean,
      default: false,
    },
    tcMoveOptions: {
      type: Array,
      default: () => [],
    },
    keywordMoveOptionsByTcKey: {
      type: Object,
      default: () => ({}),
    },
    canMoveKeywords: {
      type: Boolean,
      default: false,
    },
    moveTargets: {
      type: Object,
      default: () => ({}),
    },
    keywordMoveTargets: {
      type: Object,
      default: () => ({}),
    },
    inheritSourceOptions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    activeTechnicalCommittees() {
      return (this.committee.technicalCommittees || []).filter((tc) => !tc.deleted);
    },
  },
  methods: {
    technicalCommitteeKey(technicalCommittee, index) {
      return String(technicalCommittee.id || technicalCommittee.draftId || `tc-${index}`);
    },
    keywordMoveOptionsFor(technicalCommittee, tcIndex) {
      return this.keywordMoveOptionsByTcKey[this.technicalCommitteeKey(technicalCommittee, tcIndex)] || [];
    },
  },
};
</script>
